import { cnpjValidation } from '../../../utils/cnpjValidation'

export default function cnpj(cnpj) {
  return cnpjValidation(cnpj)
}
